import { select } from 'd3-selection';
import { timeDay, timeHour } from 'd3-time';

import { getActivityTextAccessor } from './DayInfoGraph';
import { parseDate } from '../utils/formats';
import { adjustLayout } from '../utils/layoutUtils';
import './Dashboard.css';

function render(selection) {
  const {
    activity,
    day,
    selectedExerciseIndex,
    setSelectedExerciseIndex,
    t,
    timeScale,
  } = selection.datum();

  const date = parseDate(day);
  const nightTimeStart = timeHour.offset(date, -2); // 22:00
  const nightTimeWidth =  timeScale({ time: timeHour.offset(date, 8).toISOString() }) - timeScale({ time: date.toISOString() });
  const timeObject = { time: date.toISOString() };
  const translateX = -timeScale(timeObject);

  const svg = select(selection.node().ownerSVGElement);
  const defs = svg.select('defs');
  const hClipPathId = defs.select('.hCanvasClip').node().id;

  const activityText = getActivityTextAccessor(t);
  const graphsG = selection
    .attr('clip-path', `url(#${hClipPathId})`)
  .selectAll('g.graphs')
    .data([hClipPathId], Object)
    .join('g')
    .attr('class', 'graphs')
    .attr('transform', `translate(${translateX},0)`)
    .style('visibility', hClipPathId === 'hCanvasClip' ? 'hidden' : null);

  graphsG.selectAll('g.nightTime').data([0, 1])
    .join(enter => {
      const e = enter.insert('g', 'g.activity')
        .attr('class', 'nightTime')
        .attr('transform', d => `translate(${timeScale({ time: timeDay.offset(nightTimeStart, d).toISOString() })},0)`);
      e.append('rect')
        .attr('width', nightTimeWidth)
        .attr('height', 350);
      return e;
    },
    update => update,
    exit => {
      select(this).remove();
      return exit;
    });

  function toggleSelection(i) {
    setSelectedExerciseIndex(i === selectedExerciseIndex ? undefined : i);    
  }
    
  graphsG.selectAll('g.activity').data(activity)
    .join(enter => {
      const e = enter.append('g')
        .attr('class', (d, i) => `activity${i === selectedExerciseIndex ? ' active' : ''}`)
        .attr('transform', d => `translate(${timeScale(d)},0)`);
      e.append('a')
        .attr('href', '#')
        .on('click', (event) => event.preventDefault())
      .append('text')
        .attr('class', 'adjustLayout')
        .attr('y', 390)
        .attr('text-anchor', 'middle')
        .attr('dx', d => (timeScale({ time: d.endTime}) - timeScale(d)) / 2)
        .attr('dy', '0.7em')
        .style('font-size', '24pt')
        .text(activityText);
      e.append('rect')
        .attr('width', d => (timeScale({ time: d.endTime }) - timeScale(d)))
        .attr('height', 350);
      return e;
    },
    update => update,
    exit => {
      select(this).remove();
      return exit;
    })
    .datum((d, i) => i)
    .attr('class', (d) => `activity${d === selectedExerciseIndex ? ' active' : ''}`)
    .on('click.select', (event, d) => toggleSelection(d));

  adjustLayout(graphsG);
}

const ActivityOverlay = {
  init: f => f,
  render,
  destroy: f => f,
};

export default ActivityOverlay;